module.exports = __webpack_public_path__ + "static/media/app-promo@2x.e9cb5054.png";